import { css } from "styled-components";

export const heading = css`
  font-family: "Poppins", "Hiragino Sans", "ヒラギノ角ゴシック",
    "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "Noto Sans JP",
    sans-serif;
  font-weight: 600;
`;
